// API URL
const BASE_API_URL = import.meta.env.VITE_API_URL;
export const API_BASE_URL = `${BASE_API_URL}/api/v1/public/`;

// IFRAME URL
export const IFRAME_URL = import.meta.env.VITE_IFRAME_URL;

//Og Url
export const OG_URL = `https://www.swaminarayanbhagwan.org`;

//fallback image alt text
export const FALLBACK_IMAGE_ALT_TEXT = "Swaminarayan Bhagwan";

// NOT AVAILABLE constant
export const NOT_A = "N/A";
// language constants
export const COOKIES_LANGUAGE = "language";

// export const CANONICAL_URL = "www.swaminarayanbhagwan.org";
export const CANONICAL_URL = "https://www.swaminarayanbhagwan.org";

export const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const shortMonthName = [
  { en: "Jan", gu: "જાન્યુઆરી" },
  { en: "Feb", gu: "ફેબ્રુઆરી" },
  { en: "Mar", gu: "માર્ચ" },
  { en: "Apr", gu: "એપ્રિલ" },
  { en: "May", gu: "મે" },
  { en: "Jun", gu: "જૂન" },
  { en: "Jul", gu: "જુલાઈ" },
  { en: "Aug", gu: "ઑગસ્ટ" },
  { en: "Sep", gu: "સપ્ટેમ્બર" },
  { en: "Oct", gu: "ઓક્ટોબર" },
  { en: "Nov", gu: "નવેમ્બર" },
  { en: "Dec", gu: "ડિસેમ્બર" },
];

export const MandirList = [
  { en: "karelibaug", gu: "કારેલીબાગ", img: "vadodara", value: "karelibaug" },
  { en: "vadtal", gu: "વડતાલ", img: "vadtal", value: "vadtal" },
  { en: "gadhada", gu: "ગઢડા", img: "gadhada", value: "gadhada" },
  { en: "ahmedabad", gu: "અમદાવાદ", img: "ahmedabad", value: "ahmedabad" },
  { en: "junagadh", gu: "જૂનાગઢ", img: "junagadh", value: "junagadh" },
  { en: "dholera", gu: "ધોલેરા", img: "dholera", value: "dholera" },
  { en: "bhuj", gu: "ભુજ", img: "bhuj", value: "bhuj" },
];

export const TilChinhData = [
  { en: "Ubha Maharaj Til Chinh", gu: "ઊભા મહારાજ તિલ-ચિન્હ", value: "til-chinh", img: "til-chinh" },
  { en: "Chalta Maharaj Til Chinh", gu: "ચાલતા મહારાજ તિલ-ચિન્હ", value: "walking-maharaj", img: "walking-maharaj" },
  { en: "Nilkanthvarni Til Chinh", gu: "નિલકંઠ તિલ-ચિન્હ", value: "nilkanth", img: "nilkanth" },
  { en: "Charanavind", gu: "ચરણારવિંદ", value: "charanavind", img: "charanavind" },
];

export const IMAGE_DATA_TIL_CHINH = [
  {
    key: "til-chinh",
    dziPath: "/deep-zoom/standing_maharaj.dzi",
  },
  {
    key: "nilkanth",
    dziPath: "/deep-zoom/nilkanth.dzi",
  },
  {
    key: "walking-maharaj",
    dziPath: "/deep-zoom/walking_maharaj.dzi",
  },
  {
    key: "charanavind",
    dziPath: "/deep-zoom/charanavind.dzi",
  },
];
export const youtubeLinkPrefix = "https://www.youtube.com/watch?v=";

export const BLUR_HASH = "LBH,*Yrf1vNZ00=xSvOmT}s++]Ee";

export const LANG = {
  english: "en",
  gujarati: "gu",
};

export const FALLBACK_IMAGE_URL = "/images/default-maharaj.png";

//colors

export const PLAY_PAUSE_ICON_COLOR = "#D05E2D";
export const ICON_ORANGE_COLOR = "#D05E2D";

// all audio related keys
export const AUDIO_PLAYER = {
  IS_AUDIO_PLAYING: "isAudioPlaying",
  IS_PLAY: "isPlay",
  CURRENT_AUDIO: "currentAudio",
  AUDIO_QUEUE: "audioQueue",
  ADD_TO_QUEUE: "addToQueue",
  REMOVE_FROM_QUEUE: "removeFromQueue",
  CHANGE_PLAYING_STATE: "changePlayingState",
  CHANGE_AUDIO_PLAY_STATE: "changeAudioPlayState",
  CURRENT_TIME: "currentTime",
  PLAY_ALL_AUDIO: "playAllAudio",
  MEDIA_TYPE_CONTROL: "mediaTypeControl",
};

// all video related keys
export const VIDEO_PLAYER = {
  IS_VIDEO_PLAY: "isCurrentVideoPlay",
  CURRENT_VIDEO: "currentVideo",
  CURRENT_VIDEO_POSITION: "currentVideoPosition",
  VIDEO_QUEUE: "videoQueue",
  YOUTUBE_VIDEO_IS_PLAY: "youtubeVideoIsPlay",
  VIDEO_LIGHT: "videoLight",
  PIP_MODE: "pipMode",
};

// kirtan-lyrics related key
export const SELECTED_KIRTAN_ID = "selectedKirtanId";
export const SELECTED_PAD = "selectedPad";

// gujarati route paths
export const GUJARATI_ROUTE = ["kirtan-lyrics", "chopai", "chopai-view", "blog", "news"];

//category id key name for mobile menu
export const CATEGORY = "category";
export const SELECTED_ITEM = "selectedItem";
export const SCROLL_STORAGE_KEY = "scrollPosition";

//live data key
export const LIVE_TV = "live tv";
export const RADIO = "radio";

//user data keys
export const USER_MOBILE_NUMBER = "userMobileNumber";
export const USER_COUNTRY = "userCountry";
export const USER_COUNTRY_PHONE_CODE = "userCountryPhoneCode";
export const USER_PROFILE_DATA = "userProfileData";
export const USER_IS_PASSWORD = "userIsPassword";

//user has smk
export const USER_HAS_SMK = "is_smk";
export const USER_ID = "userId";

//jwt_access_token
export const AUTH_COOKIE_TOKEN = "jwt_access_token";
export const CONTENT_TOKEN = "content_token";
export const RECAPTCHA_TOKEN = "recaptcha_token";
export const FCM_TOKEN = "fcm_token";

//quiz related keys
export const QUIZ_SESSION_KEY = "quiz-progress";
export const QUIZ_COMPLETED = "quizCompleted";
export const TIME_PER_QUESTION = "timePerQuestion"; // seconds
export const POINTS_PER_QUESTION = "pointsPerQuestion"; // points
export const IS_PLAY_AGAIN = "isPlayAgain";

//color
export const COLORS = {
  primary: "#723419 ",
  secondary: "#723419",
  white: "#FFFFFF",
  textColor: "#572713",
  iconOrange: "#d05e2d ",
  arrow_bg: "#fff5f0",
};

export const MENU_ITEM_SHAPE = {
  circular: "circular",
  rectangle: "rectangle",
  pentagon: "pentagon",
};

//calendar constant keys
export const CALENDAR = {
  CALENDAR: "calendar",
  NIRNAY: "nirnay",
  PATOTSAV: "Patotsav",
  GRAHAN: "Grahan",
  CHOGHADIYA: "Choghadiya",
  RASHI: "Rashi",
};

export const SELECTED_DATE = "selectedDate";
export const SELECTED_DATE_DATA = "selectedDateData";
export const TODAY_CALENDAR_DATE = "todayCalendarDate";

export const RELATIONS = [
  { label: "Self (કુટુંબ પ્રમુખ)", value: "self" },
  { label: "Father (પિતા)", value: "father" },
  { label: "Mother (માતા)", value: "mother" },
  { label: "Brother (ભાઈ)", value: "brother" },
  { label: "Sister (બહેન)", value: "sister" },
  { label: "Spouse (પતિ/પત્ની)", value: "spouse" },
  { label: "Son (પુત્ર)", value: "son" },
  { label: "Daughter (પુત્રી)", value: "daughter" },
  { label: "Son-in-law (પુત્રવધુ)", value: "son-in-law" },
  { label: "Daughter-in-law (પુત્રવધુ)", value: "daughter-in-law" },
  { label: "Grandfather (દાદા)", value: "grandfather" },
  { label: "Grandmother (દાદી)", value: "grandmother" },
  { label: "Grandson (પૌત્ર)", value: "grandson" },
  { label: "Granddaughter (પૌત્રી)", value: "granddaughter" },
  { label: "Uncle (કાકા)", value: "uncle" },
  { label: "Aunt (કાકી)", value: "aunt" },
];

export const BLOOD_GROUP_OPTIONS = [
  { label: "A+", value: "A+" },
  { label: "A−", value: "A-" },
  { label: "B+", value: "B+" },
  { label: "B−", value: "B-" },
  { label: "AB+", value: "AB+" },
  { label: "AB−", value: "AB-" },
  { label: "O+", value: "O+" },
  { label: "O−", value: "O-" },
];

export const MARITAL_STATUS_OPTIONS = [
  { label: "Married (વિવાહિત)", value: "married" },
  { label: "Unmarried (અવિવાહિત)", value: "unmarried" },
  { label: "Divorced (તલાકશુદા)", value: "divorced" },
  { label: "Widowed (વિધવા)", value: "widowed" },
  { label: "Vidhur (વિધુર)", value: "vidhur" },
];

export const GENDER_OPTIONS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

export const DOB_TYPE_OPTIONS = [
  { value: "tentative", label: "Tentative (અનુમાનિત)" },
  { value: "exact", label: "Exact (ખરેખર)" },
];

export const ADD_NON_SMK_REASON_OPTIONS = [
  { label: "Marriage (લગ્ન)", value: "marriage" },
  { label: "Birth (જન્મ)", value: "birth" },
  { label: "Other (અન્ય)", value: "other" },
];

export const SPLIT_FAMILY_REASON_OPTIONS = [
  { label: "Marriage (લગ્ન)", value: "marriage" },
  { label: "Divorce (છૂટાછેડા)", value: "divorce" },
  { label: "Family Expand (કુટુંબ વિસ્તરણ)", value: "family_expand" },
  { label: "Business/Job (ધંધો/નોકરી)", value: "bussiness_job" },
  { label: "Study (અભ્યાસ)", value: "study" },
  { label: "Other (અન્ય)", value: "other" },
];

export const TRANSFER_SMK_REASON_OPTIONS = [
  { label: "Marriage (લગ્ન)", value: "marriage" },
  { label: "Divorce (છૂટાછેડા)", value: "divorce" },
  { label: "Family Reason (કુટુંબ કારણ)", value: "family_reason" },
  { label: "Business/Job (ધંધો/નોકરી)", value: "bussiness_job" },
  { label: "Study (અભ્યાસ)", value: "study" },
];

export const REMOVE_SMK_REASON_OPTIONS = [
  { label: "Marriage (લગ્ન)", value: "marriage" },
  { label: "Divorce (છૂટાછેડા)", value: "divorce" },
  { label: "Death (મૃત્યુ)", value: "death" },
  { label: "Other (અન્ય)", value: "other" },
];

//thalbhet for stepper
// export const AUTH_ROUTE = ["/thalbhet1", "/registration1"];
export const AUTH_ROUTE = ["/thalbhet", "/registration"];
export const THALBHET_BASICINFO = "thalbhet_basicInfo";
export const THALBHET_RASOIINFO = "thalbhet_rasoiInfo";
export const THALBHET_CONFIRMATION = "thalbhet_confirmation";

// Apps Info query params
export const HARI_GAME_INFO = "hari-swaminarayan-game";
export const SATSANG_APP_INFO = "swaminarayan-satsang-app";
export const ADHYATMIK_HISAB = "adhyatmik-hisab";

//super header
export const SHOW_SUPER_HEADER = "showSuperHeader";
// is show view more button
export const IS_SHOW_VIEW_MORE_BUTTON = true;

//login key
export const TIMER_KEY = "otp_resend_timer";

// user activity tracking
export const USER_ACTIVITY_TRACKING_KEY = "userActivityTracking";

// page sizes
export const VIDEO_CATEGORY_LIST_PAGE_SIZE = 30;
export const PAGE_INDEX = 1;

export const IS_SINGER: string[] = ["kirtan", "dhun", "meditation"];

export const allowedCategories = ["katha", "kirtan", "meditation", "satsang", "dhun", "kirtan", "audio-book", "satsang"];

export const CATEGORY_LABELS: Record<string, { en: string; gu: string }> = {
  katha: { en: "Katha", gu: "કથા" },
  kirtan: { en: "Kirtan", gu: "કીર્તન" },
  meditation: { en: "Meditation", gu: "ધ્યાન" },
  media: { en: "Media", gu: "મીડિયા" },
  dhun: { en: "Dhun", gu: "ધૂન" },
  "book-recording": { en: "Book Recording", gu: "પુસ્તક રેકોર્ડિંગ" },
  satsang: { en: "Satsang", gu: "સત્સંગ" },
};

export const SATSANG_MEDIA_PAGE_TITLE = {
  mobile_wallpaper: { en: "Mobile Wallpaper", gu: "મોબાઇલ વોલપેપર" },
  desktop_wallpaper: { en: "Desktop Wallpaper", gu: "ડેસ્કટોપ વોલપેપર" },
  short_clip: { en: "Short Clip", gu: "શોર્ટ ક્લિપ" },
  ghar_mandir: { en: "Ghar Mandir", gu: "ઘર મંદિર" },
  health_tips: { en: "Health Tips", gu: "હેલ્થ ટીપ્સ" },
  katha_saar: { en: "Katha Saar", gu: "કથા સાર" },
  sad_vichar: { en: "Sad Vichar", gu: "સદ વિચારો" },
  ring_tone: { en: "Ring Tone", gu: "રિંગટોન" },
  temple: { en: "Temple", gu: "મંદિર" },
  "3d_wallpaper": { en: "3D Wallpaper", gu: "3D વોલપેપર" },
};

// Article type translations for Gujarati
export const ARTICLE_TYPE_TRANSLATIONS = {
  guj: {
    blog: "બ્લોગ",
    news: "સમાચાર",
  },
};

export const cacheHeaders = {
  none: "no-store", // for pages that should not be cached
  one_min: "public, max-age=60, stale-while-revalidate=300", // 1 minute
  one_hour: "public, max-age=3600, stale-while-revalidate=86400", // 1 hour
  one_day: "public, max-age=86400, stale-while-revalidate=86400", // 1 day
  one_week: "public, max-age=604800, stale-while-revalidate=2419200", // 1 week
  version: "1.2.4",
};

export const CACHE_TTL = {
  NONE: 0,
  ONE_MIN: 60, // 1 minute
  FIVE_MIN: 5 * 60, // 5 minutes
  TEN_MIN: 10 * 60, // 10 minutes
  ONE_HOUR: 60 * 60, // 1 hour
  SIX_HOUR: 6 * 60 * 60, // 6 hours
  ONE_DAY: 24 * 60 * 60, // 1 day
  ONE_WEEK: 7 * 24 * 60 * 60, // 1 week
};

// Helper function to create cache headers with current Etag
const createCacheHeaders = (ttl: number, revalidate: number, extraHeaders?: Record<string, string>) => ({
  "Cache-Control": `public, max-age=0, s-maxage=${ttl}, must-revalidate`,
  ...extraHeaders,
});

export const CACHED_PAGE = {
  INDEX: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.ONE_MIN, CACHE_TTL.FIVE_MIN);
    },
  },
  HOME: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.ONE_MIN, CACHE_TTL.FIVE_MIN);
    },
  },
  PLAYLIST: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  PLAYLIST_VIDEO_CATEGORY: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  ABOUT_US: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  ADHYATMIK_HISAB: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  APPS: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  BLOG: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN, {
        "X-Cache-Group": "article",
      });
    },
  },
  NEWS: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN, {
        "X-Cache-Group": "article",
      });
    },
  },
  CHOPAI: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  CONTACT_US: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  DAILY_DARSHAN: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.ONE_MIN, CACHE_TTL.FIVE_MIN);
    },
  },
  EVENT_IMAGES: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  FAITH: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  KIRTAN_LYRICS: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  LIVE: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.ONE_MIN, CACHE_TTL.FIVE_MIN);
    },
  },
  NIRNAY: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  NITYA_NIYAM: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  POLICY: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  SAD_GRANTH: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  SATSANG_APP: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  SATSANG_MEDIA: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  SATSANG_SEVAK: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  THAL: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  ARTICLE: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  RECIPE: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
  HARI_GAME: {
    get HEADERS() {
      return createCacheHeaders(CACHE_TTL.TEN_MIN, CACHE_TTL.ONE_MIN);
    },
  },
};
